import 'angular-ui-switch';
import toggleSwitchComponent from './toggleSwitch.component';

let toggleSwitchModule = angular.module('components.toggleSwitch', [
  'uiSwitch'
])

.component('toggleSwitch', toggleSwitchComponent)

.name;

export default toggleSwitchModule;



// WEBPACK FOOTER //
// ./client/app/components/toggleSwitch/toggleSwitch.js